module.exports = __webpack_public_path__ + "static/media/armadillo-modal.cfe058af.gif";